import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, purple, unityPurple } from '../colors';
import { GetThemeOptions } from '@/theme/theme';

export const newColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityPurple[500],
          highContrast: unityPurple[700],
          lowContrast: unityPurple[100],
        }
      : {
          main: unityPurple[400],
          highContrast: unityPurple[100],
          lowContrast: unityPurple[800],
        };
  }

  return mode === 'light'
    ? {
        main: purple[500],
        highContrast: purple[700],
        lowContrast: purple[100],
      }
    : {
        main: purple[400],
        highContrast: purple[100],
        lowContrast: purple[800],
      };
};
